export default Array.isArray;



// WEBPACK FOOTER //
// ./~/vega-util/src/isArray.js